import React from 'react';
import Icon, { COLORS, ICONS } from './icon';
import { handleClickJacking } from '../../utils/utils';

export default function IconPreviews() {
    const keys = Object.keys(ICONS).sort();

    handleClickJacking();

    const getIcons = () => {
        return keys.map((key: string) => {
            // @ts-ignore
            const name = ICONS[key];
            return (
                <div className="icon-previews-preview" key={key}>
                    <Icon
                        name={name}
                        size={50}
                        color={COLORS.WHITE}
                    />
                    <div className="icon-name">{key}</div>
                </div>
            )
        });
    };

    return (
        <div className="icon-previews">
            {getIcons()}
        </div>
    )
}